import { render } from "./DesksList.vue?vue&type=template&id=26d3df72&scoped=true"
import script from "./DesksList.vue?vue&type=script&lang=js"
export * from "./DesksList.vue?vue&type=script&lang=js"

import "./DesksList.vue?vue&type=style&index=0&id=26d3df72&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d3df72"]])

export default __exports__